// extracted by mini-css-extract-plugin
module.exports = {"assetCardRoot":"go1AS6Zc","details":"FF7lJZKP","titleWrapper":"CenRX0AE","title":"U8gt_qNX","snake":"EwgMkPIv","subtitle":"C1qYsw72"};